





























import { Component } from 'vue-property-decorator';
import { CustomerModule } from '@/store/Customers/CustomerModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import CustomerDetails from '@/components/Customers/Customers/CustomerDetails.vue';

@Component({ name: 'Customer', components: { Alert, CustomerDetails }, metaInfo: { title: 'Customers' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await CustomerModule.getCustomer(this.$route.params.id);
    }

    get customer() {
        return CustomerModule.customer;
    }

    get loading() {
        return CustomerModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
